export default {
  // Tabs
  imtokenOperationInfo: "imToken Operation Information",
  tokenPocketLoginInfo: "TokenPocket Login Information",
  bitpieCustomTags: "Bitpie Custom Tags",

  // Data statistics
  totalData: "Total",
  dataUnit: "records",

  // Loading
  loading: "Loading...",

  // Table columns
  operationType: "Operation Type",
  ipAddress: "IP Address",
  ipLocation: "IP Location",
  operationTime: "Operation Time",
  loginDevice: "Login Device",
  port: "Port",

  // Empty state
  noData: "No data",

  // Dialog title
  imtokenOperationTypeDescription: "imToken Wallet Operation Type Description",

  // Buttons
  downloadDataDetails: "Download Data Details",

  // Download file name
  downloadFileName: "TokenPocket Login Information",
};
